<!--- Componente PCWorkerDetailsRecords ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div class="main-worker-records">
    <!-- Datos Trabajador Seleccionado -->
    <div>
      <PCWorkerPresenceCard
        v-if="selectedWorker != null"
        :selected-worker="selectedWorker"
      />
    </div>

    <f7-toolbar
      v-if="selectedWorker != null"
      tabbar
      class="content-tab bg-lightsnow"
    >
      <a
        class="tab-link"
        :class="{ 'tab-link-active': (modoFrm === modosFrm.ACTIVITY) }"
        @click="ChangeDisplayOptionTabs(modoFrm.ACTIVITY)"
      >
        <span class="tabbar-label">Actividad</span>
      </a>
      <a
        class="tab-link"
        :class="{ 'tab-link-active': modoFrm === modosFrm.SUMMARY }"
        @click="ChangeDisplayOptionTabs(modoFrm.SUMMARY)"
      >
        <span class="tabbar-label">Resumen</span>
      </a>
    </f7-toolbar>

    <f7-tabs animated>
      <!-- TAB  1  ACTIVITY ( MARCAJES) -->
      <f7-tab
        id="tab-1"
        tab-active
      >
        <PCWorkerRecords
          :selected-worker="selectedWorker"
          :selected-production-line="selectedLine"
          :show-crud-options="showCrudOptions"
          :restrict-day-query="true"
          :show-crud-options-delete="showCrudOptionsDelete"
          :show-selector-consultation-date="showSelectorConsultationDate"
          :open-new-record-in-popup="openNewRecordInPopup"
          :show-time-seconds="showTimeSeconds"
          @on-success="SuccessWorkerRecord"
          @record-removed="RecordRemoved"
        />
      </f7-tab>
      <!--  ------------------------------- -->
      <!-- TAB  2  SUMMARY (TIEMPOS ACTIVITY) -->
      <!--  ------------------------------- -->
      <f7-tab id="tab-2">
        <f7-block class="no-padding content-tabla-resumen">
          <div
            v-if="selectedWorker != null"
            class="padding-horizontal content-tabla-resumen__header"
          >
            <span>
              Resumen de hoy
            </span>
            <img
              v-if="showCrudOptions"
              alt="iconWorkours"
              src="@/static/icons/ic_workhours.svg"
              @click="ResumenActividadesTrabajador()"
            >
          </div>

          <div v-if="selectedWorker != null">
            <PCActivityWorker
              ref="componentPCActivityWorker"
              :selected-worker="selectedWorker"
            />
          </div>
        </f7-block>
      </f7-tab>
    </f7-tabs>
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import PCWorkerPresenceCard from '@/components/presence/workerRecords/PCWorkerPresenceCard.vue';
import PCActivityWorker from '@/components/presence/workerRecords/PCActivityWorker.vue';
import PCWorkerRecords from '@/components/presence/workerRecords/PCWorkerRecords.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'PCWorkerDetailsRecords',
  components: {
    PCWorkerPresenceCard,
    PCActivityWorker,
    PCWorkerRecords,
  },
  props: {
    workerSelectedDefault:
      { type: Object, default: null }, // Trabajador seleccionado al inicializar el componente.
    selectedLine: { type: Object, default: null },
    showCrudOptions:
      { type: Boolean, default: true }, // Muestra el acceso a las operaciones CRUD sobre marcajes.
    showCrudOptionsDelete:
    { type: Boolean, default: true }, // Muestra el acceso a las operacion de eliminar marcajes.
    showSelectorConsultationDate:
      { type: Boolean, default: false }, // Muestra el selector de fecha de consulta.
    openNewRecordInPopup: { type: Boolean, default: false },
    showTimeSeconds: { type: Boolean, default: false },
  },

  emits: [
    'on-success',
    'record-removed',
  ],

  data() {
    return {
      selectedWorker: null, // Mantiene el trabajador seleccionado del componente.
      modoFrm: null, // Mantiene el modo del componente, Actividad o Resumen
      modosFrm: {
        ACTIVITY: 'a', // Marcajes
        SUMMARY: 'r', // Resumen Actividades
      },
    };
  },

  watch: {
    workerSelectedDefault(val) {
      if (val != null) {
        this.selectedWorker = val;
      } else {
        this.ResetComponent();
      }
    },

  },
  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.modoFrm = this.modosFrm.ACTIVITY;
      if (this.workerSelectedDefault !== undefined && this.workerSelectedDefault != null) {
        this.selectedWorker = this.workerSelectedDefault;
      }
    },
    SuccessWorkerRecord() {
      this.$emit('on-success');
    },
    ResetComponent() {
      Log(this, this.ResetComponent.name);
      this.selectedWorker = null;
      this.modoFrm = this.modosFrm.ACTIVITY;
    },

    ResumenActividadesTrabajador() {
      Log(this, this.ResumenActividadesTrabajador.name);
      f7.views.main.router.navigate('/presence/workerRecords/workerRecordsSearch');
    },

    ChangeDisplayOptionTabs(modoFrm) {
      Log(this, this.ChangeDisplayOptionTabs.name);
      // Comprobamos si estamos en la misma pestaña
      if (this.modoFrm === modoFrm) {
        return;
      }
      if (this.modoFrm === this.modosFrm.ACTIVITY) {
        this.modoFrm = this.modosFrm.SUMMARY;
        f7.tab.show('#tab-2', true);
        this.ShowSummaryMode();
      } else {
        this.modoFrm = this.modosFrm.ACTIVITY;
        f7.tab.show('#tab-1', true);
      }
    },

    ShowSummaryMode() {
      Log(this, this.ShowSummaryMode.name);
      this.$refs.componentPCActivityWorker.UpdateRecordsByActivityGroup(new Date());
    },
    RecordRemoved(recordRemoved) {
      Log(this, this.RecordRemoved.name);
      this.$emit('record-removed', recordRemoved);
    },
  },
};
</script>

<style lang="scss">
.content-tab {
  .tab-link-highlight {
    display: none;
  }

  .tab-link {
    border-right: 1px solid var(--his-silver);

    .tabbar-label {
      color: var(--his-darkness);
      text-transform: none;
      font-size: 18px;
      opacity: 0.5;
    }
  }

  .tab-link-active {
    border-bottom: 4px solid var(--his-silver);

    .tabbar-label {
      opacity: 1;
      font-weight: 400;
    }
  }
}

.content-tabla-resumen {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: var(--his-oliva);
      font-weight: 500;
      font-size: 14px;
    }

    img {
      width: 32px;
      height: 32px;
    }
  }
}

.div-registroDeMarcaje {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-registrosDeMarcajes {
  background: #fff;
}

.div-componenteDeBusquedaTrabajador {
  min-height: 82px;
  background-color: var(--his-tierra-white);
  margin-top: -15px;
  padding-top: 15px;
  padding-bottom: 5px;
}

.img-iconoAccesoResumenActividadTrabajador {
  width: 28px;
  height: 28px;
  padding-top: 12px;
  padding-bottom: 0;
}
</style>
